import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-472526c4")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "file-upload-select",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode("img", {
      src: _ctx.iconUpload,
      alt: "",
      class: "file-select-button"
    }, null, 8, ["src"]),
    _createVNode("div", {
      ref: "fileSelectName",
      class: "file-select-name"
    }, _toDisplayString(_ctx.fileName), 513),
    _createVNode("input", {
      ref: "fileUpload",
      type: "file",
      name: "file-upload-input",
      id: "file-upload-input",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeFile($event))),
      multiple: _ctx.multiple
    }, null, 40, ["multiple"])
  ]))
})